export default "__VITE_ASSET__a3efd45e__"